module.exports = __webpack_public_path__ + "static/media/step_4_rules.c88571f7.png";